import {
  MessageBox
} from 'element-ui'
import axios from 'axios' // 引用axios

export function formatDate (date, fmt) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  const o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }
  for (const k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      const str = o[k] + ''
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str))
    }
  }
  return fmt
}

function padLeftZero (str) {
  return ('00' + str).substr(str.length)
}

export function getSelectItem (oldlist, selectlsit) {
  const temp = []
  oldlist.forEach((key, val) => {
    selectlsit.forEach((v, i) => {
      if (key.id || key.sbId === v) {
        temp.push(key)
      }
    })
  })
  return temp
}

export function getTreesave (data2, nodeId2) {
  var arrRes = []
  if (data2.length === 0) {
    if (nodeId2) {
      arrRes.unshift(data2.id)
    }
    return arrRes
  }
  const rev = (data, nodeId) => {
    for (var i = 0, length = data.length; i < length; i++) {
      const node = data[i]
      if (node.id === nodeId) {
        arrRes.unshift(node.id)
        rev(data2, node.pId)
        break
      } else {
        if (node.children) {
          rev(node.children, nodeId)
        }
      }
    }
    return arrRes
  }
  arrRes = rev(data2, nodeId2)
  return arrRes
}

// 将数组变成tree 的结构
export const toTree = (list, parId) => {
  const len = list.length

  function loop (parId) {
    const res = []
    for (let i = 0; i < len; i++) {
      const item = list[i]
      if (item.orgFatherId === parId) {
        item.children = loop(item.id)
        res.push(item)
      }
    }
    return res
  }

  return loop(parId)
}

export const fn = function (arr, fid, fparentid, rootid) {
  // 复制一份，防止修改输入数组
  var carr = arr.slice()

  // 所有的即将被创建的对象
  var all = []

  // 创建root对象
  var root = {}
  root.origin = null
  root.children = []
  root.id = rootid
  root.level = 0
  root.parent = null

  // 将root添加到all
  all.push(root)

  // 循环控制变量
  var loopCount = 0
  var maxCount = carr.length

  // 方法：在all中，根据id找到对象
  var gbid = function (id) {
    for (var i = 0; i < all.length; i++) {
      if (all[i].id === id) {
        return all[i]
      }
    }
  }

  // 执行循环（最多carr.length次）
  while (loopCount++ < maxCount) {
    for (var i = 0; i < carr.length; i++) {
      var item = carr[i]
      var parent = gbid(item[fparentid])
      if (parent) {
        var obj = {}
        obj.origin = item
        obj.children = []
        obj.id = item[fid]
        obj.level = parent.level + 1
        obj.parent = parent
        parent.children.push(obj)
        all.push(obj)
        carr.splice(i, 1)
        break
      }
    }
  }

  return root
}

export function changeDetSelect (key, treeData) {
  const arr = [] // 在递归时操作的数组
  let returnArr = [] // 存放结果的数组
  let depth = 0 // 定义全局层级
  // 定义递归函数
  function childrenEach (childrenData, depthN) {
    for (var j = 0; j < childrenData.length; j++) {
      depth = depthN // 将执行的层级赋值 到 全局层级
      arr[depthN] = (childrenData[j].id)
      if (childrenData[j].id === key) {
        returnArr = arr.slice(0, depthN + 1) // 将目前匹配的数组，截断并保存到结果数组，
        break
      } else {
        if (childrenData[j].nodes) {
          depth++
          childrenEach(childrenData[j].nodes, depth)
        }
      }
    }
    return returnArr
  }

  return childrenEach(treeData, depth)
}

// // 整数转IPv4
// export function int2iP (row) {
//   const num = row.createIp
//   let str = ''
//   const tt = new Array()
//   tt[0] = (num >>> 24) >>> 0
//   tt[1] = ((num << 8) >>> 24) >>> 0
//   tt[2] = (num << 16) >>> 24
//   tt[3] = (num << 24) >>> 24
//   str = String(tt[0]) + '.' + String(tt[1]) + '.' + String(tt[2]) + '.' + String(tt[3])
//   return str
// }

// json对象转form参数
export function jsonToParam (json = {}) {
  // let params = new URLSearchParams();
  const params = new FormData()
  const arr = Object.keys(json) || []
  arr.forEach(key => {
    const value = json[key]
    if (value !== null) {
      params.append(key, json[key])
      // if (typeof value === 'object') params.append(key, JSON.stringify(json[key]));
      // else params.append(key, json[key]);
    }
  })
  return params
}

//
export function isSuccess (res) {
  return res.data.code === 200
}

// 确认操作
export function confirm (title = '提示', content = '确认操作吗', successCallback, errorCallback) {
  MessageBox.confirm(content, title, {
    confirmButtonText: '确认',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(() => {
    successCallback && successCallback()
  }).catch(() => {
    errorCallback && errorCallback()
  })
}

// 取一个随机字母ID
export function randomCoding (n = 4) {
  var result = []
  for (var i = 0; i < n; i++) {
    var ranNum = Math.ceil(Math.random() * 25)
    result.push(String.fromCharCode(65 + ranNum))
  }
  return result.join('')
}

/**
 * 获取router参数
 * @param fieldname
 */
export function getRouterQuery (fieldname) {
  if (!fieldname) return this.$route.query
  return this.$route.query[fieldname] || ''
}

/**
 * 文件下载
 */
export function downLoadFile (res) {
  const blob = new Blob([res.data], {
    type: 'application/vnd.ms-excel;charset=utf-8'
  }) //

  let fileNameSplit
  let fileName
  try {
    fileNameSplit = res.headers['content-disposition'].split('=')
    fileName = decodeURI(fileNameSplit[fileNameSplit.length - 1])
  } catch (e) {
    MessageBox({
      title: '提示',
      type: 'error',
      message: '无此文件'
    })
    return
  }

  if (window.navigator.msSaveOrOpenBlob) {
    // 兼容IE10
    navigator.msSaveBlob(blob, fileName)
  } else {
    //  chrome/firefox
    const aTag = document.createElement('a')
    aTag.download = fileName
    aTag.href = URL.createObjectURL(blob)
    aTag.click()
    URL.revokeObjectURL(aTag.href)
  }
}
/**
 * 文件下载
 */
export function downLoadFileBlob (that, res) {
  const blob = new Blob([res.data], {
    type: 'application/octet-stream;charset=UTF-8'
  })
  let fileNameSplit
  let fileName
  try {
    fileNameSplit = res.headers['content-disposition'].split('=')
    fileName = decodeURI(fileNameSplit[fileNameSplit.length - 1])
    if (window.navigator.msSaveOrOpenBlob) {
      // 兼容IE10
      navigator.msSaveBlob(blob, fileName)
    } else {
      //  chrome/firefox
      const aTag = document.createElement('a')
      aTag.download = fileName
      aTag.href = URL.createObjectURL(blob)
      aTag.click()
      URL.revokeObjectURL(aTag.href)
    }
  } catch (e) {
    that.$message.error('导出失败')
  }
}
// 采购/销售文件下载
export function uploadDown (data, pcbNumber) {
  axios.get(data, {
    responseType: 'blob' // 重要
  }).then(response => {
    const url = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    const fname = pcbNumber + '.pdf'
    link.href = url
    link.setAttribute('download', fname)
    document.body.appendChild(link)
    link.click()
  })
}
// 充值下载
export function uploadDownRecharge (data, name) {
  axios.get(data, {
    responseType: 'blob' // 重要
  }).then(response => {
    const url = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    const fname = name

    link.href = url
    link.setAttribute('download', fname)
    document.body.appendChild(link)
    link.click()
  })
}
// excel下载
export function uploadDownExcel (data, pcbNumber) {
  axios.get(data, {
    responseType: 'blob' // 重要
  }).then(response => {
    const url = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    let fname
    if (data[data.length - 3] === 'l') {
      fname = pcbNumber + '.xlsx'
    } else {
      fname = pcbNumber + '.xls'
    }

    link.href = url
    link.setAttribute('download', fname)
    document.body.appendChild(link)
    link.click()
  })
}
// 打印
export function printContent (content) {
  var tagElements = document.getElementsByTagName('iframe')
  for (var m = 0; m < tagElements.length; m++) {
    if (tagElements[m].className === 'tmp-pdf') {
      tagElements[m].parentNode.removeChild(tagElements[m])// 去除元素
    }
  }
  const iframe = document.createElement('iframe')
  iframe.className = 'tmp-pdf'
  iframe.style.display = 'none'
  iframe.src = URL.createObjectURL(content)
  document.body.appendChild(iframe)
  setTimeout(function () {
    iframe.contentWindow.print()
    URL.revokeObjectURL(content)
  }, 100)
}
/**
 * 生成文件路径
 */
export function createFileURL (res) {
  const blob = new Blob([res.data], {
    type: 'application/vnd.ms-excel;charset=utf-8'
  })
  return URL.createObjectURL(blob) || ''
}
/**
 * 表格fixed错位解决
 */
export function resetTableLayout (el, table) {
  // this.$nextTick(() => {
  //   el.forEach(item => {
  //     item.doLayout()
  //   })
  // })
}

export function encode64 (input) {
  var keyStr = 'ABCDEFGHIJKLMNOP' + 'QRSTUVWXYZabcdef' + 'ghijklmnopqrstuv' +
    'wxyz0123456789+/' + '='
  var output = ''
  var chr1
  var chr2
  var chr3 = ''
  var enc1
  var enc2
  var enc3
  var enc4 = ''
  var i = 0
  do {
    chr1 = input.charCodeAt(i++)
    chr2 = input.charCodeAt(i++)
    chr3 = input.charCodeAt(i++)
    enc1 = chr1 >> 2
    enc2 = ((chr1 & 3) << 4) | (chr2 >> 4)
    enc3 = ((chr2 & 15) << 2) | (chr3 >> 6)
    enc4 = chr3 & 63
    if (isNaN(chr2)) {
      enc3 = enc4 = 64
    } else if (isNaN(chr3)) {
      enc4 = 64
    }
    output = output + keyStr.charAt(enc1) + keyStr.charAt(enc2) +
      keyStr.charAt(enc3) + keyStr.charAt(enc4)
    chr1 = chr2 = chr3 = ''
    enc1 = enc2 = enc3 = enc4 = ''
  } while (i < input.length)

  return output
}

export function SectionToChinese (num) { // 一百以内阿拉伯数字转中文
  const chnNumChar = ['', '一', '二', '三', '四', '五', '六', '七', '八', '九']
  let strIns = ''
  if (num > 0) {
    if (num < 10) {
      strIns = chnNumChar[num]
    } else if (num < 100) {
      const nums = num.toString().split('')
      if (nums[0] === '1') {
        strIns = '十' + chnNumChar[nums[1]]
      } else {
        strIns = chnNumChar[nums[0]] + '十' + chnNumChar[nums[1]]
      }
    }
  }
  return strIns
}
// input输入框格式化限制输入(-20~ ,只可以输入两位小数)
export function formattedNumInput (num) {
  if (!isNaN(parseFloat(num)) && num !== '0-') {
    if (num.charAt(num.length - 1) === '.' && num.indexOf('.') === num.length - 1) {
      num = parseFloat(num) + '.'
    } else {
      // indexArr = []
      num = parseFloat(num)
      if (num.toString().indexOf('.') !== -1) {
        if (num.toString().length - 3 > num.toString().indexOf('.')) {
          const data = num.toString().indexOf('.') + 3
          num = parseFloat(num).toString().slice(0, data)
        }
      }
    }
  } else {
    if ((num.charAt(0) === '-' && num.length !== 1) || num === '0-') {
      num = '-'
    } else {
      num = 0
    }
  }
  return num
}
// 数组去重
export function duplicates (array) {
  var temp = [] // 一个新的临时数组
  for (var i = 0; i < array.length; i++) {
    if (temp.indexOf(array[i]) === -1) {
      temp.push(array[i])
    }
  }
  return temp
}
